export enum QuoteStatus {
  Bindable = 'bindable',
  UwDeclined = 'uw_declined',
  Paid = 'paid',
  Canceled = 'canceled',
  InReview = 'in_review',
  Future = 'future',
  Stubbed = 'stubbed',
}

export interface User {
  readonly email: string
  readonly firstName: string
  readonly lastName: string
  readonly publicId: string
}

export enum ItemStatus {
  New = 'new',
  Pending = 'pending',
  Approved = 'approved',
}

export const SERVICE_NAME = 'home-edge'
export const ANALYTICS_FORM = 'ho4'

export enum Country {
  DE = 'DE',
  NL = 'NL',
  FR = 'FR',
  GB = 'GB',
}

export enum PartnerName {
  Cardif = 'cardif',
  Revolut = 'revolut',
}
